import React from "react";
import { HardHat, LifeBuoy, Cog, BarChart3, Cloud, Shield } from "lucide-react";

const services = [
  { icon: HardHat, title: "On-site Survey & Design", body: "Tank layout mapping, pump audit, sensor placement and BOQ delivered in 48 hours." },
  { icon: Cog, title: "Turnkey Installation", body: "Certified technicians handle wiring, commissioning, calibration and user training." },
  { icon: LifeBuoy, title: "Annual Maintenance (AMC)", body: "Quarterly preventive visits, priority response, and firmware updates included." },
  { icon: BarChart3, title: "Custom Automation", body: "Multi-tank logic, softener/RO integration, staggered pumping and load sharing." },
  { icon: Cloud, title: "AquaCloud Monitoring", body: "Real-time dashboards, WhatsApp/SMS alerts, water-consumption analytics." },
  { icon: Shield, title: "Extended Warranty", body: "Up to 5 years coverage on controllers and sensors with buyback options." },
];

export default function Services() {
  return (
    <section id="services" className="border-b border-zinc-200">
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="max-w-3xl mb-16">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#002FA7] mb-4">
            /// Services & Solutions
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
            More than hardware — a full water-operations partner.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-zinc-300">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="p-8 border-r border-b border-zinc-300 bg-white hover:bg-[#EFF6FF] transition-colors duration-300"
              >
                <Icon className="w-8 h-8 text-[#002FA7] mb-6" strokeWidth={1.8} />
                <h3 className="text-xl font-semibold tracking-tight">{s.title}</h3>
                <p className="text-sm text-zinc-600 mt-3 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
